@if (selectedCurrency) {
<a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
  {{ selectedCurrency.code }} ({{ selectedCurrency.symbol }})
  <un-icon class="t-small" type="down" theme="outline"></un-icon>
</a>
}
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    @for (currency of _currencies; track currency) {
    <li nz-menu-item (click)="select(currency)">
      {{ currency.name }} ({{ currency.symbol }})
    </li>
    }
  </ul>
</nz-dropdown-menu>
